var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.885 0C7.76 0 8.268 3.523 8.268 3.523l.01 3.65h7.752v1.095H5.198S0 7.678 0 15.876c0 8.197 4.537 7.906 4.537 7.906h2.708v-3.804s-.146-4.537 4.465-4.537h7.689s4.32.07 4.32-4.175V4.247S24.373 0 15.884 0zM11.61 2.454a1.393 1.393 0 01.987 2.382 1.394 1.394 0 11-.987-2.382z",
    fill: "url(#paint0_linear_1899_83582)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.115 31.834c8.124 0 7.617-3.523 7.617-3.523l-.01-3.65H15.97v-1.096h10.832S32 24.155 32 15.958c0-8.197-4.537-7.906-4.537-7.906h-2.708v3.803s.146 4.538-4.465 4.538h-7.688s-4.32-.07-4.32 4.175v7.018s-.656 4.248 7.833 4.248zm4.275-2.455a1.393 1.393 0 01-.987-2.38 1.394 1.394 0 11.987 2.38z",
    fill: "url(#paint1_linear_1899_83582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1899_83582",
    x1: 3.075,
    y1: 2.863,
    x2: 18.933,
    y2: 18.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1899_83582",
    x1: 12.809,
    y1: 12.945,
    x2: 29.839,
    y2: 29.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.c0555338318d07317b908af61268de9c.svg";
export { ForwardRef as ReactComponent };